import { Grid, Tab, Tabs, Typography } from '@material-ui/core';
import { FuncaoParticipante, GrupoAcesso, Perfil } from 'common/genericTypes';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import { Button, LgSpace, MdSpace, SmSpace } from 'm2m.components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'store';
import ListaDeSaldoAtivos from './ativos';
import Conciliacao from './conciliacao';
import ListaDeRascunhos from './rascunhos';
import ListaDeDepositados from './depositados';
import EventosFinanceiros from './eventosFinanceiros';

const InstrumentosLista: React.FC = () => {
  const history = useHistory();

  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Leitura);
  const isParticipanteEmissor =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Emissor;
  const isParticipanteEscriturador =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Escriturador;
  const isParticipanteCustodiante =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Custodiante;
  const isParticipanteCoordenador =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Coordenador;
  const isParticipanteAgenteFiduciario =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.AgenteFiduciario;
  const isUsuarioOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;
  const isUsuarioCadastroOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.CadastroOperacoes;
  const isParticipanteCredenciado =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Credenciado;
  const isParticipanteAdministradorFiduciario =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.AdministradorFiduciario;
  const isUsuarioOperacoesMaster = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Master);
  const [tabValue, setTabValue] = useState<number>(1);

  return (
    <div style={{ margin: '0 40px 80px 0' }}>
      <Grid container direction={'row'} alignItems={'center'}>
        <Grid item lg>
          <Typography variant="h1">{'Instrumentos Financeiros'}</Typography>
        </Grid>
        {!isUsuarioLeitura && (
          <Grid item>
            {(isParticipanteEmissor || isParticipanteCredenciado || isParticipanteCustodiante || isParticipanteAdministradorFiduciario) && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => history.push(`/instrumentos/gerenciar/cadastro`)}
                data-testId="btnCadastrarInstrumento"
              >
                {'Cadastrar Instrumento Financeiro'}
              </Button>
            )}
            {((isUsuarioOperacoes && !isUsuarioOperacoesMaster) || isUsuarioCadastroOperacoes) && (
              <div style={{ display: 'grid' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => history.push(`/instrumentos/gerenciar/cadastro/interop`)}
                  data-testId="btnCadastrarInstrumentoExistente"
                >
                  {'Cadastrar Instrumento Financeiro Existente'}
                </Button>
                <SmSpace />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => history.push(`/instrumentos/gerenciar/cadastro`)}
                  data-testId="btnCadastrarInstrumento"
                >
                  {'Cadastrar Instrumento Financeiro'}
                </Button>
              </div>
            )}
          </Grid>
        )}
      </Grid>
      <LgSpace />
      <HorizontalAppBar>
        <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
          {!isParticipanteEscriturador && !isParticipanteCustodiante && !isParticipanteCoordenador && !isParticipanteAgenteFiduciario && !isParticipanteAdministradorFiduciario && <Tab label="Rascunhos" value={0} />}
          <Tab label="Depositados" value={1} />
          {!isParticipanteAgenteFiduciario && !isParticipanteAdministradorFiduciario && <Tab label="Saldo Ativos" value={2} />}
          {(isParticipanteEmissor || isParticipanteEscriturador || isParticipanteCoordenador) && <Tab label="Conciliações" value={3} />}
          {!isParticipanteAdministradorFiduciario && <Tab label="Eventos Financeiros" value={4} />}
        </Tabs>
      </HorizontalAppBar>
      <MdSpace />
      {tabValue === 0 && <ListaDeRascunhos />}
      {tabValue === 1 && <ListaDeDepositados />}
      {tabValue === 2 && <ListaDeSaldoAtivos />}
      {tabValue === 3 && <Conciliacao />}
      {tabValue === 4 && <EventosFinanceiros />}
    </div>
  );
};

export default InstrumentosLista;
